import { render } from "./Styles.vue?vue&type=template&id=48c53938"
import script from "./Styles.vue?vue&type=script&lang=ts"
export * from "./Styles.vue?vue&type=script&lang=ts"
script.render = render

export default script